import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setAuthUser, checkAuth } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const token = searchParams.get('token');
    const role = searchParams.get('role');
    const error = searchParams.get('error');

    if (error) {
      navigate('/login?error=' + error);
      return;
    }

    if (!token) {
      navigate('/login');
      return;
    }

    // Store JWT and redirect based on role
    localStorage.setItem('jwt_token', token);

    // Clean URL
    window.history.replaceState(null, '', '/auth/callback');

    // Fetch user data with the new token
    const init = async () => {
      try {
        const api = (await import('@/lib/api')).default;
        const resp = await api.get('/auth/me');
        setAuthUser(resp.data);
        const userRole = resp.data.role || role;
        if (userRole === 'admin') navigate('/admin/dashboard');
        else if (userRole === 'embassy') navigate('/embassy/dashboard');
        else navigate('/citizen/dashboard');
      } catch {
        navigate('/login');
      }
    };

    init();
  }, [navigate, setAuthUser, checkAuth, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#007FFF] mx-auto" />
        <p className="mt-4 text-muted-foreground">Connexion en cours...</p>
      </div>
    </div>
  );
}
